import styled from '@emotion/styled';
import { Skeleton, SxProps, Tooltip, Typography } from '@mui/material';
import { Component } from 'react';
interface ViewHeadingProps {
  text?: string | null;
  maxLabelLength?: number;
  sx?: SxProps;
}
interface ViewHeadingState {
  text: string;
}
export class ViewHeading extends Component<ViewHeadingProps, ViewHeadingState> {
  static defaultProps = {
    maxLabelLength: 19,
  };

  constructor(props: ViewHeadingProps) {
    super(props);
  }

  render() {
    const { text, maxLabelLength, sx } = this.props;

    return (
      <StyledViewHeading
        variant='h1'
        className='klayo-viewheading'
        sx={{
          fontSize: {
            xs: '20px',
            sm: '20px',
            md: '30px',
          },
          ...sx,
        }}
      >
        <Tooltip
          title={text && text?.length > (maxLabelLength || 0) ? text : null}
          placement='bottom-start'
        >
          {text ? <span>{text}</span> : <Skeleton width={150} height={36} />}
        </Tooltip>
      </StyledViewHeading>
    );
  }
}

const StyledViewHeading = styled(Typography)`
  &.klayo-viewheading {
    margin: 0 0 40px 0;
    white-space: break-spaces;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
